import { IAppState, rootReducer } from 'ui/reducers';
import { applyMiddleware, compose, createStore, Store, combineReducers } from 'redux';
import thunk, { ThunkAction } from 'redux-thunk';

export interface IRootState {
  sidebar: IAppState;
  $patient?: any;
  care?: any;
  p360?: any;
}

export type IThunk = ThunkAction<any, IRootState, any>;

// Catch: doing this to avoid `!` everywhere with store
let store = (null as unknown) as Store<IRootState>;

export function configureStore(initialState?: IRootState) {
  const middlewares = [thunk];

  if (process.env.NODE_ENV === 'development') {
    const logger = require('redux-logger').createLogger({
      collapsed: true,
      diff: true,
    });

    middlewares.push(logger);
  }

  const middleware = applyMiddleware(...middlewares);

  const newStore = createStore(
    combineReducers<IRootState>({ sidebar: rootReducer }),
    initialState!,
    compose(middleware),
  ) as Store<IRootState>;

  return newStore;
}

// todo: has to look at a usecase where we need to forcefully update this
export function registerReducersToRoot(registerFunction: RegisterReducer, combineWithPatientStore: string) {
  if (store) {
    return store;
  }
  const shouldCombineWithPatientStore = combineWithPatientStore.toUpperCase() === 'TRUE';
  store = shouldCombineWithPatientStore ? registerFunction({ sidebar: rootReducer }) : configureStore();
  return store;
}

export default store;
